import { ShowSupportTicketResponseSchema } from './show-support-ticket.schema';
export const showSupportTicketContract = {
    method: 'GET',
    path: '/api/v2/support/tickets/:ticketId',
    description: 'Get a support ticket with its customer-visible conversation',
    responseSchema: ShowSupportTicketResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Ticket not found, or not owned by the caller',
            503: 'Service Unavailable - support backend unreachable'
        }
    }
};

//# sourceMappingURL=show-support-ticket.contract.js.map